// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2hK9h","title":"BackImages_title__2BoV0","images":"BackImages_images__20nSs"};